import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Actions } from '../../../types/actions.type';

@Component({
  selector: 'app-mu-slider',
  templateUrl: './mu-slider.component.html',
  styleUrls: ['./mu-slider.component.sass'],
})
export class MuSliderComponent<ActionType> implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() step: number;
  @Input() min: number;
  @Input() max: number;
  @Input() actionList: Actions<ActionType, any>;
  @Input() actionSlideEnd: ActionType;

  constructor() {
    /* */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /* */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * emit action on slide end
   */
  slideEnd(): void {
    this.actionList?.emit(this.actionSlideEnd, null);
  }
}
